/**
 * Entfernt Trainer-/Dozentenhinweise aus Kapitel-HTML für Teilnehmer (1:1 zur
 * Web-App, app.js filterTrainerHtml). Trainer/Admin sehen alles unverändert.
 */
import { isTrainer } from "../state/session";

const TRAINER_PATTERN =
  /(trainer[-\s]?notiz|trainerhinweis|dozentenhinweis|dozentenleitfaden|trainer-modul|für trainer)/i;

export function filterTrainerHtml(html: string): string {
  if (isTrainer.value) return html || "";
  try {
    const doc = new DOMParser().parseFromString(`<div>${html || ""}</div>`, "text/html");
    const root = doc.body.firstElementChild;
    if (!root) return html || "";
    root.querySelectorAll("blockquote, section, details, aside, li, p").forEach((el) => {
      if (TRAINER_PATTERN.test(el.textContent || "")) el.remove();
    });
    return root.innerHTML;
  } catch {
    return html || "";
  }
}
